// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .mobile-cart-main-wrapper {
    position: relative;
    height: 100vh; /* Ensure it has a height to make the fixed element work */
    overflow: auto; /* Ensure it can scroll */
  }

  .mobile-cart-main-wrap {
    margin-top: 24px;
    position: relative; /* Ensure this container has positioning context */
    padding-bottom: 60px; /* Ensure space for the fixed footer */
  }

  .mobile-cart-main-wrap h3 {
    font-size: 22px;
    color: #1a1919;
    font-weight: 600;
    margin: 0px;
  }

  .mobile-cart-square-feet-wrap {
    margin-top: 24px;
  }

  .mobile-cart-square-feet-wrap .cart-square-image img {
    width: 50px;
  }

  .mobile-cart-square-feet-wrap h4 {
    font-size: 16px;
    color: #1a1919;
    font-weight: 600;
    margin: 0px;
    margin-top: 10px;
  }

  .booking-squarefeet-wrap p {
    font-size: 16px;
  }

  .booking-squarefeet-wrap span {
    font-size: 18px;
    font-weight: 400;
  }

  .mobile-cart-total-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .mobile-cart-total-wrap {
    padding-bottom: 10px;
  }

  .mobile-cart-total-wrap h3 {
    font-size: 18px;
    color: #1a1919;
    font-weight: 600;
    margin: 0px;
  }

  .mobile-cart-main-wrapper .mobile-booking-cart-items-wrap {
    margin-top: 30px;
    margin-bottom: 240px;
  }

  .mobile-cart-total-wrap h4 {
    font-size: 18px;
    color: #00a19b;
    font-weight: 600;
    margin: 0px;
  }

  .mobile-cart-footer-wrap {
    padding-top: 20px;
    border-top: 1px solid #f3f3f3;
    position: fixed;
    bottom: 80px;
    left: 0;
    right: 0;
    width: 100%;
    background-color: white;
    z-index: 10;
    padding: 20px 20px !important;
  }

  .mobile-notification-main-wrap {
    margin-top: 24px;
    margin-bottom: 100px;
  }

  .mobile-notification-main-wrap h3 {
    font-size: 22px;
    color: #1a1919;
    font-weight: 600;
    margin: 0px;
  }

  .notification-item-desc p {
    width: 100%;
  }

  .notification-items-wrap {
    margin-left: 14px;
  }

  .notification-order-repeat {
    margin-top: 36px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/mobile/mobilecart.css"],"names":[],"mappings":"AAAA;EACE;IACE,kBAAkB;IAClB,aAAa,EAAE,0DAA0D;IACzE,cAAc,EAAE,yBAAyB;EAC3C;;EAEA;IACE,gBAAgB;IAChB,kBAAkB,EAAE,kDAAkD;IACtE,oBAAoB,EAAE,sCAAsC;EAC9D;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;IAC7B,eAAe;IACf,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,WAAW;IACX,uBAAuB;IACvB,WAAW;IACX,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["@media (max-width: 1024px) {\n  .mobile-cart-main-wrapper {\n    position: relative;\n    height: 100vh; /* Ensure it has a height to make the fixed element work */\n    overflow: auto; /* Ensure it can scroll */\n  }\n\n  .mobile-cart-main-wrap {\n    margin-top: 24px;\n    position: relative; /* Ensure this container has positioning context */\n    padding-bottom: 60px; /* Ensure space for the fixed footer */\n  }\n\n  .mobile-cart-main-wrap h3 {\n    font-size: 22px;\n    color: #1a1919;\n    font-weight: 600;\n    margin: 0px;\n  }\n\n  .mobile-cart-square-feet-wrap {\n    margin-top: 24px;\n  }\n\n  .mobile-cart-square-feet-wrap .cart-square-image img {\n    width: 50px;\n  }\n\n  .mobile-cart-square-feet-wrap h4 {\n    font-size: 16px;\n    color: #1a1919;\n    font-weight: 600;\n    margin: 0px;\n    margin-top: 10px;\n  }\n\n  .booking-squarefeet-wrap p {\n    font-size: 16px;\n  }\n\n  .booking-squarefeet-wrap span {\n    font-size: 18px;\n    font-weight: 400;\n  }\n\n  .mobile-cart-total-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .mobile-cart-total-wrap {\n    padding-bottom: 10px;\n  }\n\n  .mobile-cart-total-wrap h3 {\n    font-size: 18px;\n    color: #1a1919;\n    font-weight: 600;\n    margin: 0px;\n  }\n\n  .mobile-cart-main-wrapper .mobile-booking-cart-items-wrap {\n    margin-top: 30px;\n    margin-bottom: 240px;\n  }\n\n  .mobile-cart-total-wrap h4 {\n    font-size: 18px;\n    color: #00a19b;\n    font-weight: 600;\n    margin: 0px;\n  }\n\n  .mobile-cart-footer-wrap {\n    padding-top: 20px;\n    border-top: 1px solid #f3f3f3;\n    position: fixed;\n    bottom: 80px;\n    left: 0;\n    right: 0;\n    width: 100%;\n    background-color: white;\n    z-index: 10;\n    padding: 20px 20px !important;\n  }\n\n  .mobile-notification-main-wrap {\n    margin-top: 24px;\n    margin-bottom: 100px;\n  }\n\n  .mobile-notification-main-wrap h3 {\n    font-size: 22px;\n    color: #1a1919;\n    font-weight: 600;\n    margin: 0px;\n  }\n\n  .notification-item-desc p {\n    width: 100%;\n  }\n\n  .notification-items-wrap {\n    margin-left: 14px;\n  }\n\n  .notification-order-repeat {\n    margin-top: 36px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
